
import "./spinner.scss"

(function($, undefined) {

	$.nette.ext("spinner", {
		before: function () {
			$("body").addClass("spinner");
		},
		complete: function () {
			$("body").removeClass("spinner");
		}
	});

})(jQuery);
